import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function EllipsisHorizontal({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <EllipsisHorizontal.Outline {...props} />
  ) : (
    <EllipsisHorizontal.Solid {...props} />
  );
}

EllipsisHorizontal.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          className="icon-primary"
          d="M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12Z"
        />
        <path
          className="icon-primary"
          d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        />
        <path
          className="icon-primary"
          d="M19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12C17 13.1046 17.8954 14 19 14Z"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

EllipsisHorizontal.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          className="icon-primary"
          d="M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12Z"
        />
        <path
          className="icon-primary"
          d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        />
        <path
          className="icon-primary"
          d="M19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12C17 13.1046 17.8954 14 19 14Z"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
